import {Dashboard} from './ui/Dashboard';
import {StoresProvider} from './ui/StoresProvider';
import {FC} from 'react';
import {CircularProgress, Typography} from '@mui/material';
import {isEmpty} from 'lodash';

export const AdminDashboard: FC = () => {
  return (
    <StoresProvider>
      {(loading, stores) => {
        if (loading) return <CircularProgress />;

        if (isEmpty(stores)) {
          return (
            <Typography variant="h6" color="text.secondary">
              Нет данных для отображения
            </Typography>
          );
        }

        return <Dashboard />;
      }}
    </StoresProvider>
  );
};
